/* eslint-disable no-undef */
export const ENABLE_DEBUGGING = process.env.REACT_APP_ENABLE_DEBUGGING === 'true';
export const amplifyConfig = {
  Auth: {
    region: process.env.REACT_APP_AWS_COGNITO_REGION,
    userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID,
    storage: window.sessionStorage,
    oauth: {
      domain: process.env.REACT_APP_AWS_OAUTH_DOMAIN,
      scope: ["email", "openid"],
      redirectSignIn: process.env.REACT_APP_AWS_OAUTH_REDIRECT_SIGNIN_URL,
      redirectSignOut: process.env.REACT_APP_AWS_OAUTH_REDIRECT_SIGNOUT_URL,
      responseType: "code"
    }
  }
},
  FederatedIdName = process.env.REACT_APP_AWS_ID_PROVIDER_NAME,
  PageSize = process.env.REACT_APP_PAGE_SIZE.split(',').map(
    (item) => parseInt(item, 10)
  ),
  RowsPerPage = parseInt(process.env.REACT_APP_ROW_PER_PAGE),
  SessionTimeOut = process.env.REACT_APP_LOGOUT_SESSION_TIMEOUT,
  InacivitySessionTimeout = process.env.REACT_APP_INACTIVITY_SESSION_TIMEOUT,
  ResendEmailIntervalSeconds = process.env.REACT_APP_RESEND_EMAIL_INTERVAL_SECONDS,
  ApiGatewayUrl = process.env.REACT_APP_API_GATEWAY_URL;
export const MapServerUrl = process.env.REACT_APP_MAP_SERVER_URL;
export const BaseMapName = process.env.REACT_APP_BASE_MAP_NAME;
export const Node_Env = process.env.NODE_ENV;
export const FAQUrl = process.env.REACT_APP_FAQ_URL; 
